import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Search from '@/components/Search'
import Lists from '@/components/Lists'
import List from '@/components/List'
import DataIndex from '@/components/DataIndex'
import FilmList from '@/components/FilmList'
import Admin from '@/components/Admin'
import Account from '@/components/Account'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
  	{
      path: '/search',
      name: 'Search',
      component: Home
    },
    {
      path: '/lists',
      name: 'Lists',
      component: Lists
    },
    {
      path: '/list/:id/',
      name: 'List',
      component: List
    },
    {
      path: '/',
      name: 'Home',
      component: Search,
      props: (route) => ({
          qTimeperiod: route.query.qTimeperiod,
          qGenres: route.query.qGenres,
          qQuality: route.query.qQuality,
          qBuzz: route.query.qBuzz,
          qSort: route.query.qSort,
          qSearchField: route.query.qSearchField,
          qSearchValue: route.query.qSearchValue
      })
    },
    {
      path: '/data-index',
      name: 'DataIndex',
      component: DataIndex
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin
    },
    {
      path: '/film-list',
      name: 'FilmList',
      component: FilmList
    },
    {
      path: '/account',
      name: 'Account',
      component: Account
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js